<template>
    <v-app>
        <v-navigation-drawer height="100%" app dark v-model="drawer" v-if="needMenu">
            <br>
            <v-list-item @click="toDashboard">
                <v-img src="@/assets/logo.png" width="50"></v-img>
                <v-list-item-title class="ml-5">
                    <span class="font-weight-bold">
                        UTC SUPERVISION
                    </span>
                </v-list-item-title>
            </v-list-item>
            <h5 class="text-right white--text mr-3 mb-2">
                v {{ version }}
            </h5>
            <v-divider class="mx-2"></v-divider>
            <v-list nav >
                <v-list-item to="/dashboard" v-if="!!user.orga">
                    <v-list-item-action>
                        <v-icon>mdi-view-dashboard-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ $vuetify.lang.t('$vuetify.app.dashboard') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <template>
                    <v-list-item to="/utc" :disabled="!user.orgaValid" v-if="!!user.orga">
                        <v-list-item-action >
                            <v-icon>mdi-cctv</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>UTC</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <br v-if="!!user.orga">
                <v-list-item to="/alarms" :disabled="!user.orgaValid" v-if="!!user.orga">
                    <v-list-item-action>
                        <v-icon>mdi-alarm-light-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ $vuetify.lang.t('$vuetify.app.alarms') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/intrusions" :disabled="!user.orgaValid" v-if="!!user.orga">
                    <v-list-item-action>
                        <v-icon>mdi-motion-sensor</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Intrusions</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/screenshots" :disabled="!user.orgaValid" v-if="!!user.orga">
                    <v-list-item-action>
                        <v-icon>mdi-image-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ $vuetify.lang.t('$vuetify.app.screenshots') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <br v-if="!!user.orga">
                <v-list-item to='/users' :disabled="!user.orgaValid" v-if="!!user.orga">
                    <v-list-item-action>
                        <v-icon>mdi-account-multiple-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ $vuetify.lang.t('$vuetify.app.users') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/account">
                    <v-list-item-action>
                        <v-icon>mdi-account-edit-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $vuetify.lang.t('$vuetify.app.account') }} 
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/organizations" v-if="!!user.orga">
                    <v-list-item-action>
                        <v-icon>mdi-office-building</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ $vuetify.lang.t('$vuetify.app.organizations') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <br>
                <v-list-item to="/support">
                    <v-list-item-action>
                        <v-icon>mdi-at</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ $vuetify.lang.t('$vuetify.app.support') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <template v-slot:append>
                <v-list-item @click="disconnect">
                    <v-list-item-action>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ $vuetify.lang.t('$vuetify.app.logout') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-navigation-drawer>
        <v-app-bar light app v-if="needMenu">
            <v-app-bar-nav-icon @click="drawer=!drawer" color="black"></v-app-bar-nav-icon>
            <v-toolbar-title>{{ $vuetify.lang.t(this.$route.name) }}</v-toolbar-title>
            <v-spacer />
            <v-toolbar-title></v-toolbar-title>
            <v-menu bottom left offset-y v-if="!!user.orga">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        elevation="0"
                        class="black--text"
                        v-bind="attrs"
                        v-on="on"
                        @click="getOrganizations()"
                    >
                    
                        <v-icon left size="25">mdi-office-building</v-icon>
                        <span>{{ user.orgaName }}</span>
                    </v-btn>
                </template>
                <v-list height="auto" class="py-0"> 
                    <v-list-item v-for="(organization, index) in organizations" :key="index" @click="changeOrganization(organization)">
                        <v-list-item-title class="text-uppercase text-center"  >{{ organization.name }}</v-list-item-title>
                    </v-list-item> 
                    <v-divider></v-divider>
                </v-list>
            </v-menu>
            <v-menu bottom left offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        elevation="0"
                        class="black--text"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon v-if="!user.phone && user.haveSMSNotif" color=red class="mr-2">mdi-phone-off</v-icon>
                        <v-icon>mdi-account-outline</v-icon>
                    </v-btn>
                </template>
                <v-list height="auto" class="py-0"> 
                    <v-list-item to ='/account'>
                        <v-list-item-title class="text-capitalize text-center">{{ user.username }}</v-list-item-title>
                    </v-list-item> 
                    <v-divider></v-divider>
                    <v-btn class="ma-2 gradient-wintech" @click="disconnect">
                        <v-icon left>mdi-logout</v-icon>
                        {{ $vuetify.lang.t('$vuetify.app.logout') }}
                    </v-btn>
                </v-list>
            </v-menu>

            <v-btn icon color="black" @click="toSupport">
                <v-icon>mdi-help-circle-outline</v-icon>
            </v-btn>
            <v-menu
                bottom
                left
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="black"
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >                        
                       <h3>{{ locale }}</h3>
                    </v-btn>
                </template>
                <v-list height="110px" > 
                    <v-list-item @click="changeLocale('en')">                    
                        <v-list-item-title class="text-capitalize text-center">EN</v-list-item-title>                        
                    </v-list-item>
                    <v-list-item @click="changeLocale('fr')">
                        <v-list-item-title class="text-capitalize text-center">FR</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-main class="grey lighten-4">
            <v-container fluid :fill-height="!needMenu" :class="{ 'pb-0' : needMenu }">
                <router-view></router-view>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';


export default {
    name: 'App',
    components: {},
    data() {
        return {
            organizations: [],
            currentOraganization: [],
            drawer: true,
            version: "",
            smsNotif: false,
        }
    },
    computed: {
        ...mapGetters({ user: "StateUser", locale: "getLocale", token: "StateToken" }),
        needMenu(){
            return this.$route.meta.requiresAuth;
        }
    },
    mounted() {
        this.getVersion();
    },
    methods: {
        ...mapActions(["LogOut", "setLocale", "ChangeGrp"]),
        async getVersion() {
            try {
                const res = await axios.get('version');
                if (res.status === 200) {
                    this.version = res.data;
                }
            } catch (error) {
                console.error(error);
            }
        },
        async getOrganizations() {
            try {
                const res = await axios.get('organizations/'+this.user.id);
                if (res.status === 200) {
                    this.organizations = res.data;
                }
            } catch (error) {
                console.error(error);
            }
        },
        toDashboard() {
            if (this.$route.path !== "/dashboard") {
                if(!this.user.orga)
                    this.$router.push("/account");
                else
                    this.$router.push("/dashboard");
            } else {
                this.$root.$emit('refreshDash');
            }
        },
        toSupport() {
            if (this.$route.path !== "/support") {
                this.$router.push("/support");
            }
        },
        disconnect() {
            this.LogOut();
            this.$router.push("/login");
        },
        async changeLocale(lang) {
            if (lang !== this.locale) {
                await this.setLocale(lang);
                this.$vuetify.lang.current = lang;
                window.location.reload();
            }
        },
        async changeOrganization(organization){
            this.user.orga = organization.id
            this.user.orgaName = organization.name
            this.user.orgaValid = organization.onValidPeriod
            this.user.role = organization.role
            await this.ChangeGrp(this.user)
            this.toDashboard();
        }
    }
}
</script>

<style>
    .table-header-text {
        color: white !important;
    }

    .v-data-table-header {
        background-color: rgb(158, 158, 158);
    }

    .v-data-table th, td {
        font-size: 17px !important;
    }

    tbody tr:nth-of-type(even) {
        background-color: rgb(221, 221, 221);
    }

    tbody tr:nth-of-type(odd) {
        background-color: white;
    }

    .v-btn {
        color: white !important;
    }

    .v-banner {
        background-color: white !important;
        margin-bottom: 2%;
    }

    .gradient-wintech {
        background: rgb(37,77,153);
        background: linear-gradient(90deg, rgba(37,77,153,1) 0%, rgba(76,180,221,1) 100%);
        color: white !important;
    }

    .v-alert.gradient-wintech:not(.v-alert--outlined) .v-alert__icon {
        color: white !important;
    }

    .v-alert.v-alert--outlined.gradient-wintech {
        color: rgba(62,143,197,1) !important;
    }
</style>